module.exports = __webpack_public_path__ + "img/Baggage.b7307b18.png";